exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-lead-components-___LeadDealSummary__picture___ke2qs{width:100%;border-radius:3px}", ""]);

// exports
exports.locals = {
	"picture": "web-flows-deal-lead-components-___LeadDealSummary__picture___ke2qs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/lead/components/LeadDealSummary.css
// module id = 1346
// module chunks = 0